import React, { Fragment, useState, useEffect } from 'react'

import { T1, T2 } from 'app/constants/reviews'
// @ts-ignore
import GlobalLoader from 'app/components/Loaders/GlobalLoader'
import Button from 'app/components/ButtonDefault'
import Divider from 'app/components/Divider'
// @ts-ignore
import { getUserFullName } from 'helpers/getUserUIData'
// @ts-ignore
import BarChart from './BarChart'
// @ts-ignore
import RadarChart from './RadarChart'
import RadarChartT2 from './ComponentsForT2/RadarChartT2'
import RadarChartT2ForPrintingSection from './ComponentsForT2/RadarChartT2ForPrintingSection'
import BarChartGrouped from './ComponentsForT2/BarChartGrouped'
// @ts-ignore
import Section from './Section'
import Wrapper from './Wrapper'
import {
  IReportsProps,
  IReportsOrganization,
  IReport,
  IReviewers,
  IOverallAvgByCompetencyForT2,
  IOverallAvgByCompetency,
} from './interface'
import WrapperBlock from './ComponentsForT2/WrapperBlock'

import './styles.scss'
import { IBarChartGroupedReviewerType } from './ComponentsForT2/BarChartGrouped/interface'
import TitleForCompetencySection from './ComponentsForT2/TitleForCompetencySection'
import { OVERALL_RATING_TITLE, YOUR_CHANGE_TITLE, TEAM_CHANGE_TITLE } from './constants'

const bc = 'reports'

export const SELF_COLOR = '147, 165, 255'
export const SUPERIOR_COLOR = '45, 216, 120'
export const PEER_COLOR = '93, 211, 255'
export const EMPLOYEE_COLOR = '247, 101, 123'

export const SUPERVISORS = 'Supervisors'
export const PEERS = 'Peers'
export const DIRECT = 'Direct'
export const SELF = 'Self'

export const COLORS_OPACITY = [
  `rgba(${EMPLOYEE_COLOR}, 0.8)`,
  `rgba(${SUPERIOR_COLOR}, 0.8)`,
  `rgba(${PEER_COLOR}, 0.8)`,
  `rgba(${SELF_COLOR}, 0.8)`,
]

export const COLORS_OPACITY_08 = {
  [SELF]: `rgba(${SELF_COLOR}, 0.8)`,
  [PEERS]: `rgba(${PEER_COLOR}, 0.8)`,
  [SUPERVISORS]: `rgba(${SUPERIOR_COLOR}, 0.8)`,
  [DIRECT]: `rgba(${EMPLOYEE_COLOR}, 0.8)`,
}

export const COLORS = [
  `rgba(${SELF_COLOR}, 1)`,
  `rgba(${PEER_COLOR}, 1)`,
  `rgba(${SUPERIOR_COLOR}, 1)`,
  `rgba(${EMPLOYEE_COLOR}, 1)`,
]

export const COLORS_BY_REVIEWER_TYPE = {
  [SELF]: COLORS_OPACITY[3],
  [PEERS]: COLORS_OPACITY[2],
  [SUPERVISORS]: COLORS_OPACITY[1],
  [DIRECT]: COLORS_OPACITY[0],
} as any

export const COLORS_BY_REVIEWER_TYPE_03 = {
  [SELF]: `rgba(${SELF_COLOR}, 0.3)`,
  [PEERS]: `rgba(${PEER_COLOR}, 0.3)`,
  [SUPERVISORS]: `rgba(${SUPERIOR_COLOR}, 0.3)`,
  [DIRECT]: `rgba(${EMPLOYEE_COLOR}, 0.3)`,
}

export const COLORS_FOR_RADAR_CHART_T2 = {
  [T1]: COLORS_BY_REVIEWER_TYPE_03,
  [T2]: COLORS_OPACITY_08,
} as any

const renderBarChartForEachQuestion = (byEachQuestion: any, reviewers: any) => {
  return byEachQuestion.map(({ title, result }: any, i: number) => (
    <div key={`${i}_each_question`} className={`${bc}__break-page`}>
      <Divider margin="0 0 40px 0" borderBottom="1px solid #dedede" />
      <BarChart data={result} title={`${i + 1}. ${title}`} reviewers={reviewers} style={{ marginTop: '40px' }} />
    </div>
  ))
}

const renderBarChartForEachQuestionForT2 = (byEachQuestion: any, reviewers: any) => {
  return byEachQuestion.map(
    ({ title, result }: { title: string; result: IBarChartGroupedReviewerType[] }, i: number) => (
      <div key={`${i}_each_question`} className={`${bc}__break-page`}>
        {i > 0 && <Divider margin="0 0 40px 0" borderBottom="1px solid #dedede" />}
        <BarChartGrouped
          data={result}
          title={`${i + 1}. ${title}`}
          reviewers={reviewers}
          layout="horizontal"
          classNameWrapper={`${bc}__each_question_t2`}
        />
      </div>
    )
  )
}

const renderOverallAvgByCompetency = (
  overallAvgByCompetency: IOverallAvgByCompetency[],
  reviewers: any,
  isPrint: boolean
) => {
  return overallAvgByCompetency.map(({ competency, overall, byAllQuestions, byEachQuestion }: any, i: number) => {
    const [isOpened, toggle] = useState(i === 0)
    const isOpen = isOpened || isPrint
    return (
      <Wrapper key={`${competency}_${i}`} marginBottom="5px" isClosed={!isOpen}>
        <BarChart
          data={byAllQuestions}
          title={competency}
          reviewers={reviewers}
          overall={typeof overall === 'number' ? overall.toFixed(1) : overall}
          isOpened={isOpen}
          handleToggle={() => {
            toggle(!isOpen)
          }}
          classNameTitle={`${bc}__1st-bar-title`}
        />
        {isOpen && byEachQuestion && renderBarChartForEachQuestion(byEachQuestion, reviewers)}
      </Wrapper>
    )
  })
}

const renderOverallAvgByCompetencyT2 = (
  overallAvgByCompetency: IOverallAvgByCompetencyForT2[],
  reviewers: IReviewers,
  isPrint: boolean
) => {
  return overallAvgByCompetency.map(
    (
      { competency, overall, byEachQuestion, participantChange, teamChange }: IOverallAvgByCompetencyForT2,
      i: number
    ) => {
      const [isOpened, toggle] = useState(i === 0)
      const isOpen = isOpened || isPrint
      return (
        <Wrapper key={`${competency}_${i}`} marginBottom="5px" isClosed={!isOpen}>
          <TitleForCompetencySection
            title={competency}
            isOpened={isOpen}
            handleToggle={() => {
              toggle(!isOpen)
            }}
            overall={`${overall.toFixed(1)}%`}
          />
          {isOpen && (
            <div style={{ display: 'flex' }}>
              <WrapperBlock>
                <BarChartGrouped
                  data={participantChange}
                  reviewers={reviewers}
                  layout="horizontal"
                  title={YOUR_CHANGE_TITLE}
                  isSmall
                  classNameTitle={`${bc}__title-horizontal-bar`}
                />
              </WrapperBlock>
              <WrapperBlock>
                <BarChartGrouped
                  data={teamChange}
                  reviewers={reviewers}
                  layout="horizontal"
                  title={TEAM_CHANGE_TITLE}
                  isSmall
                  classNameTitle={`${bc}__title-horizontal-bar`}
                />
              </WrapperBlock>
            </div>
          )}
          {isOpen && byEachQuestion && renderBarChartForEachQuestionForT2(byEachQuestion, reviewers)}
        </Wrapper>
      )
    }
  )
}

const renderAnswersToEachQuestion = (answersToEachQuestion: any, reviewers: any) => {
  return answersToEachQuestion.map(({ question, answers }: any, i: number) => (
    <Wrapper key={`${question}_${i}`}>
      <Section question={question} answers={answers} key={`${question}_${i}`} reviewers={reviewers} />
    </Wrapper>
  ))
}

// @ts-ignore
let timerReport
// @ts-ignore
let closeTimerReport

const Reports: React.FC<IReportsProps> = ({ report, isPending, organization }) => {
  if (isPending) {
    return <GlobalLoader />
  }

  const reviewType = report.get('reviewType')
  const isT1 = reviewType === T1
  const isT2 = reviewType === T2
  if (!isT1 && !isT2) {
    throw new Error('Review Type is not defined')
  }
  const reportObject = report.toJS() as IReport
  const reviewersAvgByCompetency = reportObject.reviewersAvgByCompetency
  const overallAvgByReviewerType = reportObject.overallAvgByReviewerType
  const overallAvgByCompetency = reportObject.overallAvgByCompetency
  const answersToEachQuestion = reportObject.answersToEachQuestion
  const reviewers = reportObject.reviewers
  // next fields exists only in T2 Report
  const reviewersRatingsT2 = reportObject.reviewersRatingsT2
  const organizationObject = organization.toJS() as IReportsOrganization
  const [isPrint, togglePrint] = useState(false)
  const handlePrintVersionBeforePrint = () => {
    togglePrint(true)
    // @ts-ignore
    clearTimeout(closeTimerReport)
  }
  const handlePrintVersionAfterPrint = () => {
    // @ts-ignore
    clearTimeout(timerReport)
    closeTimerReport = setTimeout(() => {
      togglePrint(false)
    }, 1000)
  }
  useEffect(() => {
    window.addEventListener('beforeprint', handlePrintVersionBeforePrint)
    window.addEventListener('afterprint', handlePrintVersionAfterPrint)

    return () => {
      window.removeEventListener('beforeprint', handlePrintVersionBeforePrint)
      window.removeEventListener('afterprint', handlePrintVersionAfterPrint)
    }
  }, [])
  return (
    <div className={bc}>
      <div className={`${bc}__wrapper`}>
        <div className={`${bc}__header`}>
          <div className={`${bc}__print-button`} style={{ opacity: 0 }} />
          <img style={{ height: '69px' }} src={organizationObject.logo} alt={organizationObject.name} />
          <Button
            onClick={() => {
              togglePrint(true)
              timerReport = setTimeout(() => {
                window.print()
              }, 500)
            }}
            className={`${bc}__print-button`}
          >
            PRINT 360 REVIEW
          </Button>
        </div>
        <div className={`${bc}__content`}>
          <Wrapper>
            <div className={`${bc}__title`}>
              <span className={`${bc}__title-s1`}>360 Review Summary</span>
              <span className={`${bc}__subtitle`}>
                {getUserFullName(report.get('firstName'), report.get('lastName'), report.get('email'))}
              </span>
            </div>
            <div className={`${bc}__radar`}>
              {isT1 ? (
                <RadarChart data={reviewersAvgByCompetency} reviewers={reviewers} />
              ) : isPrint ? (
                <RadarChartT2ForPrintingSection
                  // @ts-ignore
                  data={reviewersAvgByCompetency}
                  reviewers={reviewers}
                />
              ) : (
                <Fragment>
                  <WrapperBlock>
                    <RadarChartT2
                      // @ts-ignore
                      data={reviewersAvgByCompetency}
                      reviewers={reviewers}
                    />
                  </WrapperBlock>
                  <WrapperBlock>
                    <BarChartGrouped
                      data={reviewersRatingsT2}
                      reviewers={reviewers}
                      layout="vertical"
                      isSmall
                      isRenderTitle
                    />
                  </WrapperBlock>
                </Fragment>
              )}
            </div>
          </Wrapper>
          {isT2 && isPrint && (
            <Wrapper style={{ padding: '70px' }}>
              <BarChartGrouped
                data={reviewersRatingsT2}
                reviewers={reviewers}
                layout="horizontal"
                classNameTitle={`${bc}__1st-bar-title`}
                isRenderTitle
              />
            </Wrapper>
          )}

          {isT1 && overallAvgByReviewerType && (
            <Wrapper marginBottom="20px">
              <BarChart
                data={overallAvgByReviewerType}
                title={OVERALL_RATING_TITLE}
                reviewers={reviewers}
                classNameTitle={`${bc}__1st-bar-title`}
                isBoldBar
              />
            </Wrapper>
          )}

          {isT1 &&
            overallAvgByCompetency &&
            // @ts-ignore
            renderOverallAvgByCompetency(overallAvgByCompetency, reviewers, isPrint)}
          {isT2 &&
            overallAvgByCompetency &&
            // @ts-ignore
            renderOverallAvgByCompetencyT2(overallAvgByCompetency, reviewers, isPrint)}
          {answersToEachQuestion && renderAnswersToEachQuestion(answersToEachQuestion, reviewers)}
        </div>
        <div className={`${bc}__copyright`}>{`Copyright ${new Date().getFullYear()}. 360 review`}</div>
      </div>
    </div>
  )
}

export default Reports
